//import { Page, Text, View, Document, StyleSheet,PDFViewer,PDFDownloadLink } from '@react-pdf/renderer';
import ReportsBase from './ReportsBase';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Button, MenuItem, Select, FormControl, InputLabel, Stack } from '@mui/material';
import React from 'react';
import axios from 'axios';
import { useEffect,useState } from 'react';
import '../App.css';
import { DownloadForOffline } from '@mui/icons-material';
import { set } from 'date-fns';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as XLSX from 'xlsx';


function AdminReports()
{
  const [financials,setFinancials]=useState([{}]);
  const [peerGroups,setPeerGroups]=useState([{}]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [statusMessage, setStatusMessage] = useState('');
  const [peerGroupName, setPeerGroupName] = useState('');
  const [ytdFinancials, setYtdFinancials] = useState([{}]);
  const [fiscalFinancials, setFiscalFinancials] = useState([{}]);
  const [launchDL,setLaunchDL] = useState(false);
  const [launchExcel, setLaunchExcel] = useState(false);
  const reportCount = 8;

  // Generate array of years from 2020 to present
  const currentYear = new Date().getFullYear();
  const years = Array.from(
      { length: currentYear - 2017 + 1 }, 
      (_, i) => currentYear - i
  );

  //Axios call to retrieve peer group report
  useEffect(()=>{
    refreshPeers();
},[]);

useEffect(()=>{
    if(launchDL){
        dlReport();
        setLaunchDL(false);
    }
},[fiscalFinancials]);

useEffect(() => {
    if (launchExcel) {
        dlExcel();
        setLaunchExcel(false);
    }
}, [fiscalFinancials]);

useEffect(()=>{
    setYtdFinancials(financials?financials.filter(f => f.isYTD):[{}]);
    setFiscalFinancials(financials?financials.filter(f => !f.isYTD):[{}]);   
},[financials]);


function refreshPeers() {
    console.log('Calling API:', process.env.REACT_APP_API_URL + 'PeerGroups'); // Log the full URL

    axios({
        url: process.env.REACT_APP_API_URL + 'PeerGroups',
        method: "Get",
        data: {},
    }).then((res) => {
        console.log('API Response:', res.data); // Log the response data
        
        // Filter for active peer groups and sort by name
        const sortedPeerGroups = res.data
            .filter(pg => pg.isActive)  // Only keep active peer groups
            .sort((a, b) => (a.peerName || '').localeCompare(b.peerName || ''));
        
        console.log('Sorted Peer Groups:', sortedPeerGroups); // Log the processed data
        setPeerGroups(sortedPeerGroups);
    }).catch((err) => {
        console.log('API Error:', err); // Log any errors in detail
        console.log('Error Response:', err.response); // Log the error response if available
    });
}
const prepReport=(peerGroupId,peerGroupName)=>{
    setPeerGroupName(peerGroupName);
    setLaunchDL(true);
    refreshFinancials(peerGroupId);
}

const prepExcel = (peerGroupId, peerGroupName) => {
    setPeerGroupName(peerGroupName);
    setLaunchExcel(true);
    refreshFinancials(peerGroupId);
};

const sortByDivisionAndCompany = (a, b) => {
    const divisionCompare = (a.division || '').localeCompare(b.division || '');
    return divisionCompare === 0 
        ? (a.companyName || '').localeCompare(b.companyName || '')
        : divisionCompare;
};

const refreshFinancials = (peerGroupId) => {
    axios({
        url: `${process.env.REACT_APP_API_URL}FiscalReport?peerGroupId=${peerGroupId}&year=${selectedYear}`,
        method: "Get",
        data: {},
    }).then((res) => {
        const uniqueDivisions = [...new Set(res.data.map(f => f.division))].sort();
            
        // Sort financials by company name within each division
        const sortedByDivision = uniqueDivisions.flatMap(division => 
            res.data
                .filter(f => f.division === division)
                .sort((a, b) => (a.company?.name || '').localeCompare(b.company?.name || ''))
        );

        //setFinancials(sortedByDivision);
        // Split and sort YTD financials
        const sortedYtdFinancials = res.data
        .filter(f => f.isYTD)
        .sort(sortByDivisionAndCompany);

        // Split and sort Fiscal financials
        const sortedFiscalFinancials = res.data
        .filter(f => !f.isYTD)
        .sort(sortByDivisionAndCompany);
        console.log(sortedFiscalFinancials);

        setFinancials(res.data);
        setYtdFinancials(sortedYtdFinancials);
        setFiscalFinancials(sortedFiscalFinancials);

    }).catch((err) => {
        console.log(err);
        setStatusMessage("Error loading financial data");
    });
};

const dlReport = () => {
    // Use the appropriate financials based on selected tab
    if(fiscalFinancials.length === 0 && ytdFinancials.length === 0){
        setStatusMessage("No financials found");
        return 0;
    }

    let numberOfFiscalGroups = Math.floor(fiscalFinancials.length / reportCount);
    const fyRemainder = fiscalFinancials.length % reportCount;
    numberOfFiscalGroups += (fyRemainder > 0 ? 1 : 0);
    const ytdRemainder = ytdFinancials.length % reportCount;
    let numberOfYtdGroups = Math.floor(ytdFinancials.length / reportCount);
    numberOfYtdGroups += (ytdRemainder > 0 ? 1 : 0);
    //Check both otherwise fail out
    

    //I need to use this code to add a title per Division and per YTD/FY
    // doc.setFontSize(20);
    // doc.text("My PDF Title", 105, 20, { align: 'center' });
    // So I need to figure out divisions and then add this

    if(numberOfFiscalGroups > 0 && numberOfYtdGroups > 0){//I need to do YTD And FY
        const doc = new jsPDF({ orientation: 'l', format: 'letter' });
        // doc.setFontSize(20);
        // doc.text(peerGroupName + " Fiscal Year", 105, 20, { align: 'center' });
        for (let i = 0; i < numberOfFiscalGroups; i++) {
            if (i > 0) {
                doc.autoTable({


                html: "#tblFY" + i,
                useCss: true,
                theme: 'plain',
                startY: doc.lastAutoTable.finalY + 15,
                pageBreak: 'avoid'
            });
            } else {
                doc.autoTable({ html: "#tblFY" + i, useCss: true, theme: 'plain', startY: 30 });
            }
        }
        doc.addPage();
        // doc.setFontSize(20);
        // doc.text(peerGroupName + " YTD", 105, 20, { align: 'center' });
        


        for (let i = 0; i < numberOfYtdGroups; i++) {
            if (i > 0) {
            doc.autoTable({
                  html: "#tblYTD" + i,
                  useCss: true,
                  theme: 'plain',
                  startY: doc.lastAutoTable.finalY + 15,
                  pageBreak: 'auto'
                  });
            } else {
                doc.autoTable({ html: "#tblYTD" + i, useCss: true, theme: 'plain', startY: 30 });
            }
        }
        

        doc.save('testdl.pdf');
        const uri = doc.output('datauristring');
        const newTab = window.open();
        newTab?.document.write(`<iframe width='100%' height='100%' src='${uri}'></iframe>`);
        setStatusMessage('');
    }else
    {
        setStatusMessage("Either FY or YTD data is missing, please check the selected year");
    }
};

const dlExcel = () => {
    if (fiscalFinancials.length === 0 && ytdFinancials.length === 0) {
        setStatusMessage("No financials found");
        return;
    }

    try {
        // Create workbook
        const wb = XLSX.utils.book_new();
        
        // Process Fiscal Year data - process ALL tables, not just the first one
        if (fiscalFinancials.length > 0) {
            console.log('=== FISCAL YEAR DATA PROCESSING ===');
            console.log('Total fiscal financials:', fiscalFinancials.length);
            
            let allFiscalData = [];
            let tableIndex = 0;
            let table = document.querySelector(`table#tblFY${tableIndex}`);
            
            while (table) {
                console.log(`Processing table tblFY${tableIndex}`);
                const tableRows = table.querySelectorAll('tr');
                console.log(`Found ${tableRows.length} rows in table`);
                
                const excelData = processTableRows(tableRows);
                console.log(`Processed excel data for tblFY${tableIndex}:`, excelData.length, 'rows');
                console.log('First row (headers):', excelData[0]);
                console.log('Second row (subheaders):', excelData[1]);
                
                if (allFiscalData.length === 0) {
                    // First table - use its data as base
                    allFiscalData = excelData;
                    console.log('Using first table as base');
                } else {
                    // Subsequent tables - merge columns horizontally
                    console.log(`Merging columns from tblFY${tableIndex}`);
                    
                    // Merge header rows (company names)
                    if (excelData[0] && excelData[0].length > 1) {
                        // Skip the first cell (title) and add company columns
                        const companyColumns = excelData[0].slice(1);
                        allFiscalData[0] = allFiscalData[0].concat(companyColumns);
                        console.log('Merged header row:', allFiscalData[0]);
                    }
                    
                    // Merge subheader row (Value, %)
                    if (excelData[1] && excelData[1].length > 1) {
                        const subheaderColumns = excelData[1].slice(1);
                        allFiscalData[1] = allFiscalData[1].concat(subheaderColumns);
                        console.log('Merged subheader row:', allFiscalData[1]);
                    }
                    
                    // Merge data rows
                    for (let rowIndex = 2; rowIndex < Math.min(allFiscalData.length, excelData.length); rowIndex++) {
                        if (excelData[rowIndex] && excelData[rowIndex].length > 1) {
                            const dataColumns = excelData[rowIndex].slice(1); // Skip metric name
                            allFiscalData[rowIndex] = allFiscalData[rowIndex].concat(dataColumns);
                        }
                    }
                }
                
                tableIndex++;
                table = document.querySelector(`table#tblFY${tableIndex}`);
            }
            
            console.log(`Total fiscal tables processed: ${tableIndex}`);
            console.log(`Final fiscal data rows: ${allFiscalData.length}`);
            console.log('Final fiscal data sample:', allFiscalData.slice(0, 3));
            
            if (allFiscalData.length > 0) {
                // Create worksheet from the combined data
                const ws = XLSX.utils.aoa_to_sheet(allFiscalData);
                
                // Add merge cells for the header row
                ws['!merges'] = [];
                for (let i = 1; i < allFiscalData[0].length; i += 2) {
                    ws['!merges'].push({ 
                        s: { r: 0, c: i }, 
                        e: { r: 0, c: i + 1 } 
                    });
                }
                
                // Set column widths for better readability
                const colWidths = allFiscalData[1].map(col => ({ wch: Math.max(12, col.length + 2) }));
                ws['!cols'] = colWidths;
                
                // Add worksheet to workbook
                XLSX.utils.book_append_sheet(wb, ws, "Fiscal Year");
            }
        }
        
        // Process YTD data - process ALL tables, not just the first one
        if (ytdFinancials.length > 0) {
            console.log('=== YTD DATA PROCESSING ===');
            console.log('Total YTD financials:', ytdFinancials.length);
            
            let allYtdData = [];
            let tableIndex = 0;
            let table = document.querySelector(`table#tblYTD${tableIndex}`);
            
            while (table) {
                console.log(`Processing table tblYTD${tableIndex}`);
                const tableRows = table.querySelectorAll('tr');
                console.log(`Found ${tableRows.length} rows in table`);
                
                const excelData = processTableRows(tableRows);
                console.log(`Processed excel data for tblYTD${tableIndex}:`, excelData.length, 'rows');
                console.log('First row (headers):', excelData[0]);
                console.log('Second row (subheaders):', excelData[1]);
                
                if (allYtdData.length === 0) {
                    // First table - use its data as base
                    allYtdData = excelData;
                    console.log('Using first table as base');
                } else {
                    // Subsequent tables - merge columns horizontally
                    console.log(`Merging columns from tblYTD${tableIndex}`);
                    
                    // Merge header rows (company names)
                    if (excelData[0] && excelData[0].length > 1) {
                        // Skip the first cell (title) and add company columns
                        const companyColumns = excelData[0].slice(1);
                        allYtdData[0] = allYtdData[0].concat(companyColumns);
                        console.log('Merged header row:', allYtdData[0]);
                    }
                    
                    // Merge subheader row (Value, %)
                    if (excelData[1] && excelData[1].length > 1) {
                        const subheaderColumns = excelData[1].slice(1);
                        allYtdData[1] = allYtdData[1].concat(subheaderColumns);
                        console.log('Merged subheader row:', allYtdData[1]);
                    }
                    
                    // Merge data rows
                    for (let rowIndex = 2; rowIndex < Math.min(allYtdData.length, excelData.length); rowIndex++) {
                        if (excelData[rowIndex] && excelData[rowIndex].length > 1) {
                            const dataColumns = excelData[rowIndex].slice(1); // Skip metric name
                            allYtdData[rowIndex] = allYtdData[rowIndex].concat(dataColumns);
                        }
                    }
                }
                
                tableIndex++;
                table = document.querySelector(`table#tblYTD${tableIndex}`);
            }
            
            console.log(`Total YTD tables processed: ${tableIndex}`);
            console.log(`Final YTD data rows: ${allYtdData.length}`);
            console.log('Final YTD data sample:', allYtdData.slice(0, 3));
            
            if (allYtdData.length > 0) {
                // Create worksheet from the combined data
                const ws = XLSX.utils.aoa_to_sheet(allYtdData);
                
                // Add merge cells for the header row
                ws['!merges'] = [];
                for (let i = 1; i < allYtdData[0].length; i += 2) {
                    ws['!merges'].push({ 
                        s: { r: 0, c: i }, 
                        e: { r: 0, c: i + 1 } 
                    });
                }
                
                // Set column widths for better readability
                const colWidths = allYtdData[1].map(col => ({ wch: Math.max(12, col.length + 2) }));
                ws['!cols'] = colWidths;
                
                // Add worksheet to workbook
                XLSX.utils.book_append_sheet(wb, ws, "YTD");
            }
        }
        
        // Generate Excel file and trigger download
        XLSX.writeFile(wb, `${peerGroupName.replace(/\s+/g, '_')}_report.xlsx`);
        setStatusMessage('');
    } catch (error) {
        console.error("Error generating Excel file:", error);
        setStatusMessage("Error generating Excel file");
    }
};

function processTableRows(tableRows) {
    console.log('processTableRows called with', tableRows.length, 'rows');
    
    if (!tableRows || tableRows.length === 0) {
        console.log('No table rows, returning empty array');
        return [];
    }
    
    // Extract data from the table
    const excelData = [];
    
    // Process first header row (company names with colSpan="2")
    const firstHeaderRow = tableRows[0];
    const firstHeaderCells = firstHeaderRow.querySelectorAll('th');
    console.log('First header row has', firstHeaderCells.length, 'cells');
    
    const firstHeaderData = [];
    
    // First cell (title) doesn't span
    firstHeaderData.push(firstHeaderCells[0].textContent.trim());
    console.log('Title cell:', firstHeaderCells[0].textContent.trim());
    
    // Process company cells (they have colSpan="2")
    for (let i = 1; i < firstHeaderCells.length; i++) {
        const cell = firstHeaderCells[i];
        const colSpan = parseInt(cell.getAttribute('colspan') || '1');
        const companyName = cell.textContent.trim();
        
        console.log(`Cell ${i}: "${companyName}" (colSpan: ${colSpan})`);
        
        // Add the company name for each column it spans
        for (let j = 0; j < colSpan; j++) {
            firstHeaderData.push(companyName);
        }
    }
    
    console.log('First header data:', firstHeaderData);
    excelData.push(firstHeaderData);
    
    // Process second header row (Metric Name, Value, %)
    const secondHeaderRow = tableRows[1];
    const secondHeaderCells = secondHeaderRow.querySelectorAll('th');
    console.log('Second header row has', secondHeaderCells.length, 'cells');
    
    const secondHeaderData = [];
    
    secondHeaderCells.forEach(cell => {
        secondHeaderData.push(cell.textContent.trim());
    });
    
    console.log('Second header data:', secondHeaderData);
    excelData.push(secondHeaderData);
    
    // Process the rest of the rows normally
    for (let rowIndex = 2; rowIndex < tableRows.length; rowIndex++) {
        const row = tableRows[rowIndex];
        const rowData = [];
        const cells = row.querySelectorAll('th, td');
        
        cells.forEach(cell => {
            rowData.push(cell.textContent.trim());
        });
        
        excelData.push(rowData);
    }
    
    console.log('processTableRows returning', excelData.length, 'rows total');
    return excelData;
}

    // Add some console logs to debug
    useEffect(() => {
        console.log('Peer Groups:', peerGroups);
    }, [peerGroups]);

    return(
        <>
        <div className="container">
            <div style={{
                padding: '20px',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                gap: '20px'
            }}>
                <FormControl style={{ minWidth: 200 }}>
                    <InputLabel>Fiscal Year</InputLabel>
                    <Select
                        value={selectedYear}
                        label="Fiscal Year"
                        onChange={(e) => setSelectedYear(e.target.value)}
                    >
                        {years.map((year) => (
                            <MenuItem key={year} value={year}>
                                {year}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <div style={{ color: 'red' }}>{statusMessage}</div>
            </div>

            {/* Add null check and length check */}
            {peerGroups && peerGroups.length > 0 ? (
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '20px',
                    padding: '20px'
                }}>
                    {peerGroups.map((peerGroup) => (
                        <div key={peerGroup.peerGroupId} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            minWidth: '200px',
                            flex: '1 1 auto',
                            textAlign: 'center',
                            padding: '15px',
                            border: '1px solid #ddd',
                            borderRadius: '4px'
                        }}>
                            <h3 style={{ marginBottom: '10px' }}>{peerGroup.peerName}</h3>
                            <Stack spacing={1} width="100%">
                                <Button 
                                    variant="outlined" 
                                    onClick={() => prepReport(peerGroup.peerGroupId, peerGroup.peerName)} 
                                    size='small' 
                                    startIcon={<DownloadForOffline />}
                                >
                                    Download PDF
                                </Button>
                                <Button 
                                    variant="outlined" 
                                    onClick={() => prepExcel(peerGroup.peerGroupId, peerGroup.peerName)} 
                                    size='small' 
                                    startIcon={<FileDownloadIcon />}
                                    color="success"
                                >
                                    Download Excel
                                </Button>
                            </Stack>
                        </div>
                    ))}
                </div>
            ) : (
                <div>No peer groups available</div>
            )}
            <div style={{maxHeight: '0',overflowY: 'disable'}}>
                <ReportsBase financials={fiscalFinancials} reportCount={reportCount} htmlBaseId="tblFY" forPrint={true} peerName={peerGroupName} />
                <ReportsBase financials={ytdFinancials} reportCount={reportCount} htmlBaseId="tblYTD" forPrint={true} peerName={peerGroupName} />
            </div>
        </div>
        </>
    );
}

export default AdminReports;